<template>
  <v-container fluid grid-list-lg>
    <v-layout row>
      <v-flex xs12 md5 style="position:relative">
        <v-btn fab color="green" dark small absolute right @click="resetFm"><v-icon>add</v-icon></v-btn> 
        <v-dialog v-model="dialog" persistent max-width="290">          
          <v-card>
            <form @submit.prevent="saveRole">
              <v-card-title class="title">New Role</v-card-title>
              <v-card-text>
                <v-text-field v-model="fm.name" label="name" :error="!!error.name.length" :error-messages="error.name"/>
                <v-text-field v-model="fm.description" label="description" :error="!!error.description.length" :error-messages="error.description"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1"  text @click="dialog = false">cancel</v-btn>
                <v-btn color="green darken-1" type="submit" text :loading="loading">save</v-btn>
              </v-card-actions>
            </form>
          </v-card>
        </v-dialog>              
        <v-text-field flat dense filled
          v-model="term"
          append-icon="search"
          label="Search Roles"
          single-line
          hide-details
          style="width:200px"
        ></v-text-field>     
        <v-data-table class="mt-4 ramping" dense
          :headers="headers"
          :items="items"
          :search="term"
          :loading="loading"
          loading-text="Loading... Please wait"
          :items-per-page="15"    
          :mobile-breakpoint="0"        
        >           
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item,i) in items" :key="item.name" style="cursor:pointer" :class="$route.query.id===item.name ?'green lighten-4':''">
                <td @click="showDetail(item)">{{ i+1 }}</td>
                <td @click="showDetail(item)">{{ item.name }}</td>
                <td @click="showDetail(item)">{{ item.description }}</td>
                <td><v-btn color="error" icon small v-if="$route.query.id===item.name" @click="removeRole(item.name)"><v-icon>delete</v-icon></v-btn></td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 md7>
        <roles-child v-if="showChild" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RolesChild   from './roles-child'
import { debounce } from 'lodash'
import Model from '@/app/models/Admin'
const  model = new Model()

export default {
  components:{RolesChild},
  data () {
    return {
      term : null,
      items: [],
      headers : [
        {text:'No', value:'no'},
        {text:'Name', value:'name'},
        {text:'Desciption', value:'description'},
        {text:'#', value:'action'}
      ],     
      page : 0,      
      totalPages : 0,      
      loading : false,
      dialog : false,
      status: {1:'active',0:'inactive'},
      fm : {name:null, description:null, type:1},
      error : {name:[], description:[], type:[]},
    }
  },
  computed: {    
    formReady () {
      return !(this.error.name.length)
    },  
    showChild () {
      return this.$route.query.id !== undefined;
    }, 
  },
  watch: {
    '$route.query.id'(newId) {
      if(newId === undefined)
      this.readItems() 
    },
    page(newPage){
      this.readItems(newPage) 
    }  
  },
  created () {
    this.readItems()
  },  
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    resetFm(){
      this.fm.name = null;
      this.fm.description = null;
      this.dialog = true; 
    },

    showDetail(e){
      this.$router.replace({query:{id:e.name}});
    },

    readItems (page = 0) {
      this.loading = true

      const params = {
        perPage: 20,
        page: page,
        q: this.term
      }

      model.roles(params)
        .then(response => {          
          response.data.forEach((item, i)=>{item.no = (i+1)});
          this.items = response.data;          
          //this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },

    saveRole(){
      this.error.name = this.fm.name ? [] : ['Name is required']
      if (!this.formReady) {
        return
      }
      this.loading = true;
      model.addRole(this.fm).then(res=>{
        if(res.status === 200){
          this.readItems();
          this.dialog = false;
        } else {
          this.showRoleModal = true;      
        }
        this.loading = false;
      })            
    },

    removeRole(id){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {                 
        if (result.value) {                    
          model.deleteRole({id:id}).then(()=>{          
              this.$router.replace({query:{}})              
          })
        }
      });
    },
  },  
}
</script>
<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>